<template>
    <div>
        <h3 v-if="layout.title">{{ layout.title }}</h3>
        <div v-for="(group, i) in layout.children" :key="i">
            <h4 class="group-title" v-if="group.title">{{ group.title }}</h4>
            <div :class="group.id ? group.id + ' flex-row mb-4' : 'flex-row mb-4'">
                <template v-for="(control, j) in group.children">
                    <div
                        :key="j"
                        v-if="control.type === 'spacer'"
                        :style="{ flex: control.width || 1, 'padding-right': control.noPadding ? '0' : 16 * (control.width || 1) + 'px' }"
                        v-text="control.text ? control.text : ''"
                        :class="control.class || ''"
                    ></div>
                    <FormControl
                        v-else
                        :key="j"
                        :model="model"
                        :schema="schema"
                        :fieldName="control.id ? control.id : control"
                        @change="change"
                        :style="{ flex: control.width || 1, 'padding-right': control.noPadding ? '0' : 16 * (control.width || 1) + 'px' }"
                        class="dynamic-control"
                        :ageAt="ageAt"
                        :rankAt="rankAt"
                    />
                </template>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormGroup',
    props: ['schema', 'layout', 'model', 'ageAt', 'rankAt'],
    mounted() {},
    methods: {
        change(field) {
            this.$emit('change', { field, value: this.model.data[field] });
        },
    },
};
</script>

<style scoped lang="scss">
.flex-row {
    display: flex;
}

.dynamic-control {
    padding-right: 16px;
    align-self: flex-start;
    overflow: hidden;
}

.group-title {
    margin-top: 24px;
    margin-bottom: 8px;
}
</style>
